module.exports = __webpack_public_path__ + "static/media/icon-google.c406518a.svg";